<template>
    <svg width="30" height="35" viewBox="0 0 30 35" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.18182 5V2.5H21.8182V5H8.18182ZM7.5 0C6.37034 0 5.45455 0.839465 5.45455 1.875V2.5H4.09091C1.83155 2.5 0 4.17893 0 6.25V31.25C0 33.321 1.83155 35 4.09091 35H25.9091C28.1684 35 30 33.321 30 31.25V6.25C30 4.17893 28.1684 2.5 25.9091 2.5H24.5455V1.875C24.5455 0.839465 23.6296 0 22.5 0H7.5ZM24.5455 5V5.625C24.5455 6.66052 23.6296 7.5 22.5 7.5H7.5C6.37034 7.5 5.45455 6.66052 5.45455 5.625V5H4.09091C3.3378 5 2.72727 5.55965 2.72727 6.25V31.25C2.72727 31.9403 3.3378 32.5 4.09091 32.5H25.9091C26.6621 32.5 27.2727 31.9403 27.2727 31.25V6.25C27.2727 5.55965 26.6621 5 25.9091 5H24.5455Z" />
    </svg>
  </template>
  
  <style scoped>
  svg {
    color: #59E3FF; /* Color por defecto */
    transition: color 0.3s ease-in-out;
  }
  </style>